<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <div class="page-tit__wrap">
      <h1 class="page-tit__sub">신고포상제</h1>
      <p class="page-tit">공동 운영사 신고 범위</p>
    </div>
    <!-- 참여 기업 리스트 -->
    <section class="section-pt">
      <h2 class="section-title">{{ title }}</h2>
      <div class="notice-box">
        <p class="notice-box__text" v-dompurify-html="content"></p>
      </div>
      <!-- 기업 리스트 -->
      <div class="operation_rg_table"></div>
      <table class="board-list type-m-none-thead">
        <caption>
          공동 운영사 신고 범위
        </caption>
        <colgroup>
          <col width="5%" />
          <col width="35%" />
          <col width="50%" />
          <col width="10%" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">번호</th>
            <th scope="col">업체명</th>
            <th scope="col">허용 범위</th>
            <th scope="col">수정일</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td class="no-field">{{ index + 1 }}</td>
            <td class="tit-field">{{ item.orgNm.join(", ") }}</td>
            <td class="info-field">
              <div v-for="(line, i) in item.range.split('-')" :key="i">
                <template v-if="i > 0">- </template>{{ line.trim() }}
              </div>
            </td>
            <td class="no-filed">
              {{ convertDateFormat(item.modDate) || "-" }}
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>
<script>
import dt from "@/component/DateTime.js";
import { inject, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const axios = inject("axios");
    const store = useStore();
    const showLoading = () => store.dispatch("loading/show");
    const hideLoading = () => store.dispatch("loading/hide");

    // data 정의
    const items = ref([]);
    const title = ref("");
    const content = ref("");

    //methods 정의
    const getList = () => {
      showLoading();
      axios
        .post("/core/pu/view/operation-range/get", {})
        .then((res) => {
          if (res.data.resType === "RES_OK") {
            items.value = res.data.resList[0].orgList;
            title.value = res.data.resList[0].title;
            content.value = res.data.resList[0].content;
          } else {
            items.value = [];
            alert(res.data.resMsg);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          hideLoading();
        });
    };
    const convertDateFormat = (date) => {
      return dt.dateFormat(date);
    };
    // life cycle 정의
    onMounted(() => {
      getList();
    });

    // html에서 사용될 데이터 정의
    return {
      items,
      title,
      content,
      convertDateFormat,
    };
  },
};
</script>
